import React, { Component } from 'react';

import * as renewalLeaseWizardActions from '../../../../actions/renewalLeaseWizardActions';
import * as notificationActions from '../../../../actions/notificationActions';

import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { localize } from 'react-localize-redux';

import InternalDocumentPortal from '../../../../components/byesign/internalDocumentPortal';

let renewalLeaseWizard = connect(
  store => {
    let userType = null;
    if (!store.userTypes.loginAuth) {
      userType = 'lead';
    } else {
      userType = store.userTypes.loginAuth;
    }

    return {
      signatureSuccess: store.renewalLeaseWizard.signatureSuccess,
      signatureRenewalYearly: store.renewalLeaseWizard.signatureRenewalYearly,
      signatureRenewalMonthly: store.renewalLeaseWizard.signatureRenewalMonthly,
      documentToSign: store.renewalLeaseWizard.documentToSign,
      userType: userType,
    };
  },
  dispatch => {
    return {
      getRenewalOptions: document_id => {
        dispatch(renewalLeaseWizardActions.renewalOptions(document_id));
      },
      renewMonthToMonth: document_id => {
        dispatch(renewalLeaseWizardActions.tenantMonthToMonth(document_id));
      },
      updateDocumentToSign: documentToSign => {
        dispatch(renewalLeaseWizardActions.updateDocumentToSign(documentToSign));
      },
      displayLoader: verbiage => {
        dispatch(notificationActions.displayLoader(verbiage));
      },
      displaySuccessfulLeaseRenewed: () => {
        dispatch(notificationActions.showSuccess('leaseSuccessfullyRenewed'));
      },
    };
  }
)(
  class RenewalLeaseWizard extends Component {
    constructor(props) {
      super(props);
      this.state = {
        page: 1,
      };
    }

    componentDidMount() {
      if (!this.props.userType || !this.props.documentToSign) {
        this.returnToDashboard();
      }
    }

    goToPage = page_number => {
      this.setState({ page: page_number });
    };

    nextPage = () => {
      this.setState({ page: this.state.page + 1 });
    };

    previousPage = () => {
      this.setState({ page: this.state.page - 1 });
    };

    diplayRenewalLeaseCycle = () => {
      if (
        this.props.userType === 'lead' &&
        (this.props.documentToSign.document_type === 'N2' ||
          this.props.documentToSign.document_type === 'N1')
      ) {
        this.props.displayLoader('retrieve your renewal options`');
        this.props.getRenewalOptions(this.props.documentToSign.document_uuid);
        this.goToPage(2);
      }
    };

    returnToDashboard = () => {
      if (this.props.userType === 'lead') {
        browserHistory.push('/dashboard');
      } else if (this.props.userType === 'landlord') {
        browserHistory.push('/companies/dashboard');
      }
    };

    renewMonthToMonth = () => {
      this.props.renewMonthToMonth(this.props.documentToSign.document_uuid);
    };

    renewYearly = () => {
      this.goToPage(3);
    };

    onContinueRenewYearly = () => {
      this.props.displaySuccessfulLeaseRenewed();
      this.returnToDashboard();
    };

    render() {
      const { page } = this.state;

      return (
        <div>
          {page === 3 &&
            this.props.documentToSign &&
            this.props.documentToSign.document_type === 'LEASE_RENEWAL' && (
              <InternalDocumentPortal
                {...this.props.documentToSign}
                onContinue={this.onContinueRenewYearly}
              />
            )}
        </div>
      );
    }
  }
);

export default localize()(renewalLeaseWizard);
